module.exports = __webpack_public_path__ + "static/assets/a7af26ddae0196fc67d5cbbfba49a629.svg";